import { getCampaignFormSchema } from '../services/getCampaignFormSchema';
import { normalizeCampaignSchema } from '../utils/normalizeCampaignSchema';
export const fetchCampaignForm = async () => {
    const response = await getCampaignFormSchema();
    const schema = normalizeCampaignSchema(response);
    return {
        success: response?.success ?? false,
        errors: response?.errors ?? [],
        groups: schema,
    };
};
